import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { FestivalProvider } from "@/context/FestivalContext";
import { FestivalDecorations } from "@/components/FestivalDecorations";
import { SmoothScroll } from "@/components/SmoothScroll";
import { AgeGate } from "@/components/AgeGate";
import { CookieBanner } from "@/components/CookieBanner";
import { MaintenanceGate } from "@/components/MaintenanceGate";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AdminReset from "@/pages/AdminReset";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ProductDetail from "@/pages/ProductDetail";
import Catalog from "@/pages/Catalog";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";
import Gdpr from "@/pages/Gdpr";
import CondizioniAcquisto from "@/pages/CondizioniAcquisto";
import CondizioniLegali from "@/pages/CondizioniLegali";
import CondizioniConsegna from "@/pages/CondizioniConsegna";
import PoliticaRimborso from "@/pages/PoliticaRimborso";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <CartProvider>
        <BrowserRouter>
          <FestivalProvider>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Catalog />} />
              <Route path="/birra/:id" element={<ProductDetail />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/reset" element={<AdminReset />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/gdpr" element={<Gdpr />} />
              <Route path="/condizioni-acquisto" element={<CondizioniAcquisto />} />
              <Route path="/condizioni-legali" element={<CondizioniLegali />} />
              <Route path="/condizioni-consegna" element={<CondizioniConsegna />} />
              <Route path="/politica-rimborso" element={<PoliticaRimborso />} />
            </Routes>
          </SmoothScroll>
          <AgeGate />
          <CookieBanner />
          <MaintenanceGate />
          <FestivalDecorations />
          </FestivalProvider>
        </BrowserRouter>
      </CartProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141A14",
            border: "1px solid rgba(232,226,210,0.15)",
            color: "#E8E2D2",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
          },
        }}
      />
    </div>
  );
}

export default App;
